import React from "react";
import "../../../components/entities/entities.scss";

const AlertMessage = ({
  type = "success", // 'success' or 'error'
  summary,
  detail,
  handleClose,
  otherAction,
  handleOtherAction,
  className,
}) => {
  const isError = type === "error";

  return (
    <div
      className={`alert__message ${isError ? "error" : "success"} ${className || ""}`}
    >
      <div>
        <i
          className={`pi ${isError ? "pi-times-circle" : "pi-check-circle"} alert__icon`}
        />
        <div>
          <span className="alert__summary">{summary}&nbsp;</span>
          <span className="alert__detail">{detail}</span>
          {otherAction && (
            <span className="alert__other" onClick={handleOtherAction}>
              {otherAction}
            </span>
          )}
        </div>
      </div>
      <i className="pi pi-times alert__close" onClick={handleClose} />
    </div>
  );
};

export default AlertMessage;
